import React from "react";
import { Spinner } from "../../components/Spinner/Spinner";
import style from "./FullPageSpinner.module.scss";

export const FullPageSpinner: React.FC = () => {
  return <div className={style.fullpagewrapper}></div>;
};
